import queryString from "query-string";
import { analytics } from "./analytics";

const parseQueryParams = (location: Location): any => {
  try {
    let queryParams: any = {
      path: location?.pathname
    };

    if (location?.search?.length > 0) {
      const { query } = queryString.parseUrl("" + location);
      queryParams = {
        queryParams,
        ...query
      }
    }
    
    return queryParams;
  } catch (e) {
    analytics.trackException(e);

    // return an empty set if unable to parse the query params
    return {};
  }
};

export default parseQueryParams;
